module.exports = __webpack_public_path__ + "static/40-58465fc51db3fcae52d526f1db979951.png";